import { ProductCart } from ".."

type GenerateCartProps = {
  cartParams: {
    productId: string
    quantity: string
  }[]
  allProducts: ProductCart[]
}

type QueryURLParam = `${number}-${number}`

export function formatCartParams(query: QueryURLParam[]) {
  const cartParams: {
    productId: string
    quantity: string
  }[] = []

  query.forEach((param) => {
    const [productId, quantity] = param.split("-")

    if (!productId || !quantity) return

    if (!cartParams.find((cartParam) => cartParam.productId === productId)) {
      cartParams.push({ productId, quantity })
    }
  })

  return cartParams
}

export function generateCart({ cartParams, allProducts }: GenerateCartProps) {
  let initCart: ProductCart[] = []

  cartParams.forEach((cartParam) => {
    const { productId, quantity } = cartParam
    const product = allProducts.find(
      (product) => product.productId === Number(productId)
    )

    // If product is not found, skip it
    if (!product) return

    // TODO: check if the same product is already in the cart
    initCart.push({
      ...product,
      quantity: Number(quantity),
      price: String(Number(product.price) * Number(quantity)),
      extCallValue: String(Number(product.extCallValue) * Number(quantity))
    })
  })

  return initCart
}
